import styled from 'styled-components';

import { wideBreakpoints } from '../../../components/layouts/wideContainer';
import { BorderRadius } from '../../../tokens/borderRadius';
import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';
import { BaseButton } from '../../buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '../../inputSimple';

export const InputPhone = styled(phoneDecorator(InputSimple))<{ width?: number }>`
    width: ${props => props.width || '100%'};
    margin-bottom: 8px;

    @media(max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const InputName = styled(nameDecorator(InputSimple))<{ width?: number }>`
    width: ${props => props.width || '100%'};
    margin-bottom: 8px;

    @media(max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const Inputs = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin-top: 24px;
    gap: 12px;
    align-items: flex-start;

    @media(max-width: ${wideBreakpoints.mobile}) {
        flex-wrap: wrap;
        margin-top: 16px;
        display: block;
    }
`;

export const Container = styled.div<{ waitStatus: boolean }>`
    opacity: ${props => props.waitStatus ? '1' : '.5'};
    flex-direction: column;
    background: ${COLORS.BgMain};
    padding: 32px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    position: relative;
`;

export const Title = styled.div`
    ${FONTS.H3};

    @media(max-width: ${wideBreakpoints.mobile}) {
        padding-right: 20px;
        max-width: 290px;
    }
`;

export const Description = styled.div`
    ${FONTS.S};
    margin-top: 18px;
`;

export const ChildrenBlock = styled.div`
    margin-top: 18px;
`;

export const Button = styled(BaseButton)`
    max-width: 143px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const LegalWrap = styled.div`
    gap: 10px;
    margin-bottom: 16px;
    flex-wrap: nowrap;

    label {

        @media (max-width: ${wideBreakpoints.mobile}) {
            margin-top: 2px;
            align-items: flex-start;
        }

        input[type="checkbox"] {
            width: 16px;
            height: 16px;

            &:checked {
                &:after {
                    mask-size: 8px 5px;
                }
            }
        }
    }
`;
